import { GeneralResultItem } from "../types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";

const GeneralCard = (props: GeneralResultItem) => {
  const { url, linkText, intro } = props;

  return (
    <Card>
      <Card.Block>
        <Heading level={2}>
          <Link href={url} rel="noopener noreferrer">
            {linkText}
          </Link>
        </Heading>
        {intro && <Paragraph>{intro}</Paragraph>}
      </Card.Block>
    </Card>
  );
};

export default GeneralCard;
